import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { mobile: String, title: String }

  connect() {
    const dialog = this.element.closest("dialog")
    if (!dialog) return

    dialog.dataset.mobile = this.mobileValue
    this.application.getControllerForElementAndIdentifier(dialog, "dialog")?.setTitle(this.titleValue)
  }
}
